module.exports = __webpack_public_path__ + "img/canada-eye-and-ear-diseases-female.a1bc6ba6.png";